import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';

const DeleteTaskModal = ({ isOpen, onClose, onConfirm, task, loading }) => {
  if (!isOpen || !task) return null;

  return (
    <div className="modal-overlay" style={{ zIndex: 1002 }}>
      <div className="modal-container">
        <div className="modal-header">
          <h2>Delete Task</h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p style={{ color: '#d32f2f', fontWeight: 'bold', marginBottom: '15px' }}>
            Are you sure you want to delete this task? This action cannot be undone.
          </p>
          <div className="task-delete-details">
            <div className="detail-row" style={{ marginBottom: '10px' }}>
              <span className="detail-label" style={{ fontWeight: '600' }}>Patient:</span>
              <span className="detail-value">{task.patient?.name || 'Unknown Patient'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label" style={{ fontWeight: '600' }}>Task Description:</span>
              <div className="detail-value" style={{
                padding: '10px',
                backgroundColor: '#f8f9fa',
                borderRadius: '4px',
                marginTop: '6px',
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word'
              }}>
                {task.text || 'No description'}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="task-submit-button"
            onClick={onConfirm}
            disabled={loading}
            style={{ backgroundColor: '#dc3545' }}
          >
            {loading ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              'Delete Task'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteTaskModal;
